// extracted by mini-css-extract-plugin
export default {"downloads_container":"ProductDownloads_downloads_container__fDraJ"};